import React, { Component } from 'react';
import ReportWidget from './ReportWidget';
import LoadingPage from '../LoadingPage';
import Chart from '../../util/chart';
import { convertToArrayOfObjects } from '../../util/report';

class WEBAR2Widget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      agingDetail: {},
      isReady: false,
    };

    this.handleData = this.handleData.bind(this);
  }

  handleData({ data, cols }) {
    // transform array of positional data to array of json objects
    data = convertToArrayOfObjects(data, cols);

    let current = 0.00;
    let valueOver30 = 0.00;
    let valueOver60 = 0.00;
    let valueOver90 = 0.00;
    let valueOver120 = 0.00;

    data.forEach((row) => {
      const currnt = parseFloat(row.currnt);
      const overthirty = parseFloat(row.overthirty);
      const oversixty = parseFloat(row.oversixty);
      const overninety = parseFloat(row.overninety);
      const overonetwenty = parseFloat(row.overonetwenty);

      current += !isNaN(currnt) ? currnt : 0.00;
      valueOver30 += !isNaN(overthirty) ? overthirty : 0.00;
      valueOver60 += !isNaN(oversixty) ? oversixty : 0.00;
      valueOver90 += !isNaN(overninety) ? overninety : 0.00;
      valueOver120 += !isNaN(overonetwenty) ? overonetwenty : 0.00;
    });

    const agingDetail = [
      { label: 'Current', value: current },
      { label: '> 30 Days', value: valueOver30 },
      { label: '> 60 Days', value: valueOver60 },
      { label: '> 90 Days', value: valueOver90 },
      { label: '> 120 Days', value: valueOver120 },
    ];

    this.setState({ agingDetail, isReady: true }, this.renderCharts);
  }

  renderCharts() {
    Chart.makePieChart('webar2-widget-chart-1', {
      titles: [{
        text: 'A/R Aging Breakdown',
      }],
      dataProvider: this.state.agingDetail,
      balloonText: '<span style="font-size:14px">[[title]]<br><b>$[[value]]</b> ([[percents]])</span>',
    });
  }

  render() {
    return (
      <ReportWidget
        pageName="WEBAR2A"
        reportOptions={['5', 'ALL']}
        handleData={this.handleData}
      >
        {this.state.isReady ?
          <div id="webar2-widget-chart-1" className="carousel-cell" /> :
          <LoadingPage />
        }
      </ReportWidget>
    );
  }
}

export default WEBAR2Widget;
